import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Pagination, Search } from '../Table';
import CopyRight from '../Pages/CopyRight';
import Loader from '../Pages/Loader';
import ProcessLoader from '../Components/ProcessLoader';
import DropDonwlLimit from '../Components/DropDonwlLimit';
import TooltipWrapper from '../Components/TooltipWrapper';
import { DownloadSample } from '../Components/DownloadSample';

const PFReport = () => {
    const navigate = useNavigate();
    const [entity, setEntity] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);
    const [loader, setLoader] = useState(false);
    const [month, setMonth] = useState({
        month: null
    });
    const [selectedEmployee, setSelectedEmployee] = useState({ _id: "", full_name: "" });
    const [employeeData, setEmployeeData] = useState([]);

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        if (disable || (month?.month) || (selectedEmployee?._id)) {
            getReport();
            setEntity([]);
        }
        getEmployee();
    }, [disable, navigate, month, selectedEmployee]);

    const getEmployee = () => {
        const myurl = `${PAY_URL}/user/get-all-employee`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            // console.log(response.data, '$$$')
            if (response?.data?.success) {
                const data = response?.data?.data
                const filterData = data.filter((e) => e.firm_id === localStorage.getItem('PAY_USER_FIRM_ID'));
                setEmployeeData(filterData);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            toast.error("Something went wrong");
            console?.log("Errors", error);
        });
    }

    const commentsData = useMemo(() => {
        let computedComments = entity;

        entity?.forEach((record) => {
            if (Array.isArray(record?.items)) {
                computedComments = [...record.items];
            }
        });

        computedComments = computedComments.filter(item => item && Object.keys(item).length > 0);

        if (search) {
            computedComments = computedComments.filter(
                (report) =>
                    report?.employeeName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.employee_id?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.card_no?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }

        setTotalItems(computedComments.length);

        return computedComments.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );

    }, [currentPage, search, limit, entity]);

    const getReport = () => {
        const formData = new URLSearchParams();
        formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        formData.append('employee', selectedEmployee?._id);
        formData.append('month', month?.month);

        const myurl = `${PAY_URL}/user/list-pf-report`;

        axios({
            method: "POST",
            url: myurl,
            data: formData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            if (response?.data?.success === true) {
                const data = response?.data?.data
                setEntity(data);
                setDisable(false);
            } else {
                toast.error(response?.data?.message);
                setDisable(false);
            }
        }).catch((error) => {
            toast.error(error.response?.data?.message || "Something went wrong");
            setDisable(false);
        });
    }
    const handleMonthChange = (e) => {
        const { name, value } = e.target;
        setMonth({
            [name]: value
        })
    };

    const handleEmployeeChange = (e) => {
        const selectedId = e.target.value;
        const selectedEmp = employeeData.find(emp => emp._id === selectedId);

        setSelectedEmployee({
            _id: selectedEmp?._id || "",
            full_name: selectedEmp?.full_name || "",
        });
    };

    const handleDownloadFile = () => {
        if (month?.month) {
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
            bodyFormData.append('month', month?.month);
            bodyFormData.append('employee', selectedEmployee?._id);
            bodyFormData.append("print_date", true)
            DownloadSample({ url: 'pf-report-xlsx', bodyFormData: bodyFormData, filename: 'PF Report' });
        } else {
            toast.error("Please select a month to download!");
        }
    }

    const downloadReport = () => {
        if (month?.month) {
            setLoader(true);
            const myurl = `${PAY_URL}/user/pf-report-download`;
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
            bodyFormData.append('month', month?.month);
            bodyFormData.append('employee', selectedEmployee?._id);
            bodyFormData.append("print_date", true)
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
            }).then((response) => {
                if (response.data.success === true) {
                    const fileUrl = response.data.data.file;
                    toast.success(response?.data?.message);
                    window.open(fileUrl, '_blank');
                } else {
                    toast.error(response?.data?.message);
                }
            }).catch((error) => {
                console.log(error, '!!');
                toast.error(error?.response?.data.message);
            }).finally(() => {
                setLoader(false);
            })
        } else {
            toast.error('Please select the month');
        }
    }


    const handleRefresh = () => {
        setDisable(true);
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">PF Report Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">PF Report Report Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row justify-content-end align-items-center">
                        <div className='col-md-4 col-lg-4 col-sm-12'>
                            <select className="form-select form-control" name="month" value={month?.month} onChange={handleMonthChange}
                                aria-label="Default select example">
                                <option value=''>Select Month</option>
                                <option value='1'>January</option>
                                <option value='2'>February</option>
                                <option value='3'>March</option>
                                <option value='4'>April</option>
                                <option value='5'>May</option>
                                <option value='6'>June</option>
                                <option value='7'>July</option>
                                <option value='8'>August</option>
                                <option value='9'>September</option>
                                <option value='10'>October</option>
                                <option value='11'>November</option>
                                <option value='12'>December</option>
                            </select>
                        </div>

                        <div className='col-md-4 col-lg-4 col-sm-12'>
                            <select
                                className="form-select form-control"
                                value={selectedEmployee._id}
                                onChange={handleEmployeeChange}
                                aria-label="Default select example"
                            >
                                <option value=''>Select Employee</option>
                                {employeeData.map(e => (
                                    <option key={e._id} value={e._id}>{e.full_name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-sm-12 col-md-4">
                            <div className="row justify-content-end">
                                <div className="col-md-12 mb-2">
                                    {/* <label htmlFor="month" className="form-label">&nbsp;</label> */}
                                    <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                        <div className="seletePage d-flex gap-2 align-items-center ">
                                            {/* <p className="mb-0">Rows per page:</p> */}
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <DropDonwlLimit limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                <TooltipWrapper tooltipText="Refresh">
                                                    <div className="refreshPage">
                                                        <button className="btn btn-refresh" type='button' onClick={handleRefresh}>
                                                            <i className="fa-solid fa-arrows-rotate"></i>
                                                        </button>
                                                    </div>
                                                </TooltipWrapper>
                                            </div>
                                            <TooltipWrapper tooltipText="Download Excel File">
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='button' onClick={handleDownloadFile}>
                                                        <i className="fa-solid fa-file"></i>
                                                    </button>
                                                </div>
                                            </TooltipWrapper>
                                            <TooltipWrapper tooltipText="Download PF Report">
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='button' onClick={downloadReport}>
                                                        {loader ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                                    </button>
                                                </div>
                                            </TooltipWrapper>
                                        </div>
                                        <div className="tableSearch">
                                            <form action="">
                                                <Search
                                                    onSearch={(value) => {
                                                        setSearch(value);
                                                        setCurrentPage(1);
                                                    }} />
                                                <span className="search">
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        month && (
                            <div className="card p-3 ">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <table className="table table-striped custom-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Employee Name</th>
                                                        <th>Card No.</th>
                                                        <th>UAN No.</th>
                                                        <th>Work Days</th>
                                                        <th>PT Amount</th>
                                                        <th>Total Salary</th>
                                                        <th>Total Deduction</th>
                                                        <th>Net. Salary</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) => (
                                                        <tr key={elem?._id}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.employeeName}</td>
                                                            <td>{elem?.card_no}</td>
                                                            <td>{elem?.uan_no || "-"}</td>
                                                            <td>{elem?.work_day ? parseFloat(elem.work_day.toFixed(2)) : "0.00"}</td>
                                                            <td>{elem?.ptAmount ? parseFloat(elem.ptAmount.toFixed(2)) : "0.00"}</td>
                                                            <td>{elem?.total_salary ? parseFloat(elem.total_salary.toFixed(2)) : "0.00"}</td>
                                                            <td>{elem?.total_deduction ? parseFloat(elem.total_deduction.toFixed(2)) : "0.00"}</td>
                                                            <td>{elem?.net_salary ? parseFloat(elem.net_salary.toFixed(2)) : "0.00"}</td>
                                                        </tr>
                                                    ))}

                                                    <tr>
                                                        <td colSpan={4} className='text-center fw-bold'>Total</td>
                                                        <th>
                                                            {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.work_day || 0), 0).toFixed(2))}
                                                        </th>
                                                        <th>
                                                            {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.ptAmount || 0), 0).toFixed(2))}
                                                        </th>
                                                        <th>
                                                            {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.total_salary || 0), 0).toFixed(2))}
                                                        </th>
                                                        <th>
                                                            {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.total_deduction || 0), 0).toFixed(2))}
                                                        </th>
                                                        <th>
                                                            {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.net_salary || 0), 0).toFixed(2))}
                                                        </th>
                                                    </tr>


                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colspan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row align-center mt-3 user-account">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                    aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                <div className="dataTables_paginate paging_simple_numbers"
                                                    id="DataTables_Table_0_paginate">
                                                    <Pagination
                                                        total={totalItems}
                                                        itemsPerPage={limit}
                                                        currentPage={currentPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    ) : <Loader />}
                    <CopyRight />
                </div>
            </div>
        </div>
    )
}

export default PFReport